export default "__VITE_ASSET__e2d695b8__"